import {
  FormLabelInput,
  TitleInputContainer,
  TitleDescription,
  MessageInputContainer,
  FormLabel,
  InputContainer,
  FormInput,
  FormNote,
} from "@/components/ui/form-elements";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import EdsSearchableSelect from "../EdsSearchableSelect";
import {
  ActionButtonContainer,
  ButtonsListContainer,
} from "./ButtonsNodeEditor.styled";
import NodeContext from "../../context/NodeContext";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import {
  buttonOptions,
  mappingOptions,
  BUTTON_TYPE,
  NODE_TYPE,
  toolbar,
} from "../../utils/constants";
import AddIcon from "../../assets/images/addIcon.svg";
import DeleteIcon from "../../assets/images/deleteIcon.svg";
import { ReactComponent as MoreVertical } from "../../assets/images/moreVertical.svg?react";
import { v4 as uuidv4 } from "uuid";
import { Editor } from "react-draft-wysiwyg";
import { getHTMLToDraft } from "../../utils/helper";
import ResponseVariable from "../ResponseVariable/index";
import { Switch } from "@/components/ui/switch";
import Tooltip from "@mui/material/Tooltip";
import { ButtonNodeEditorConstants } from "./constants";
import { LABELS } from "../../utils/labels";
import { FLOW_TYPE_SCREENING, FLOW_TYPE_RECONNECT, FLOW_TYPE_FAQ } from "../../constants";
import { AlertTriangle, CheckIcon, PlusCircle } from "lucide-react";
import SkipToQuestionDropdown from "../SkipToQuestionDropdown";
import { MultiSelectSearchable } from "@/components/ui/multi-select";

function ButtonItem({ button, index }) {
  const {
    selectedNodeInfo,
    updateNode,
    deleteNode,
    isEditable,
    profileType,
      saveData,
      atsPlatform,
      mappingLookupData
  } = useContext(NodeContext);
  const [isOpen, setIsOpen] = useState();
  const [isMappingOpen, setIsMappingOpen] = useState(false);
  const ref = useRef();

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  useEffect(() => {
    if (!isOpen) return;

    setTimeout(() => {
      window.addEventListener("click", handleClose);
    }, 300);

    return () => {
      window.removeEventListener("click", handleClose);
    };
  }, [ref, isOpen, handleClose]);

  return (
    <div
      className="item"
      style={{
        width: "100%",
        // marginLeft: isEditable ? "10px" : "0px",
      }}
    >
      <div className="input-container">
        <div className="inp-cont">
          <div className="relative">
            <Input
              className={profileType === FLOW_TYPE_SCREENING ? "pr-[85px]" : "pr-2.5"}
              value={selectedNodeInfo?.data?.buttons[index].titleText}
              onChange={(e) => {
                if (e.target.value.length > 120) {
                  return;
                }

                const newButtons = selectedNodeInfo?.data?.buttons;
                newButtons[index].titleText = e.target.value;
                updateNode(button?.buttonNodeId, {
                  ...button,
                  titleText: e.target.value,
                });
                updateNode(selectedNodeInfo.id, {
                  ...selectedNodeInfo?.data,
                  buttons: newButtons,
                });
              }}
              placeholder="Choice"
              readOnly={!isEditable}
              required
            />
            {(selectedNodeInfo?.data?.buttons[index].titleText === "" ||
              selectedNodeInfo?.data?.buttons[index].titleText === null) && (
              <Tooltip title="This value is required.">
                <AlertTriangle
                  className="absolute right-2.5 top-2.5 text-[#ffcc00]"
                  size={18}
                />
              </Tooltip>
            )}
          </div>
          {!button.mappingType && (
            <Input
              className={`mt-2.5 ${profileType === FLOW_TYPE_SCREENING ? "pr-[85px]" : "pr-2.5"}`}
              value={selectedNodeInfo?.data?.buttons[index].optionValue}
              onChange={(e) => {
                if (e.target.value.length > 120) {
                  return;
                }

                const newButtons = selectedNodeInfo?.data?.buttons;
                updateNode(button?.buttonNodeId, {
                  ...button,
                  optionValue: e.target.value,
                });
                updateNode(selectedNodeInfo.id, {
                  ...selectedNodeInfo?.data,
                  buttons: newButtons,
                });
                newButtons[index].optionValue = e.target.value;
              }}
              placeholder="Value"
              readOnly={!isEditable}
            />
          )}
          {isEditable && atsPlatform && (profileType === FLOW_TYPE_SCREENING || profileType === FLOW_TYPE_RECONNECT) && button.mappingType && (() => {
            const activeMappingOption = mappingOptions.find((opt) => opt.platformType === atsPlatform && opt.value === button.mappingType);
            if (!activeMappingOption) return null;
            const lookupOptions = mappingLookupData
              .filter((item) => item.mappingType === button.mappingType)
              .map((item) => ({
                label: item.key,
                value: item.value,
                ...(item.group ? { group: item.group } : {}),
              }));
            if (activeMappingOption.isMultiSelect === false) {
              return (
                <EdsSearchableSelect
                      options={lookupOptions}
                      className="dropdown-value-control"
                  value={button[activeMappingOption.dataField] || ""}
                  onChange={(value) => {
                    const newButtons = selectedNodeInfo?.data?.buttons;
                    newButtons[index][activeMappingOption.dataField] = value || "";
                    updateNode(selectedNodeInfo.id, {
                      ...selectedNodeInfo?.data,
                      buttons: newButtons,
                    });
                    updateNode(button?.buttonNodeId, {
                      ...button,
                      [activeMappingOption.dataField]: value || "",
                    });
                  }}
                  placeholder={activeMappingOption.placeholder}
                  isDisabled={!isEditable}
                />
              );
            }
            return (
              <MultiSelectSearchable
                options={lookupOptions}
                selected={
                  typeof button[activeMappingOption.dataField] === "string"
                    ? button[activeMappingOption.dataField].split("||").filter(Boolean)
                    : (button[activeMappingOption.dataField] || "")
                }
                onChange={(values) => {
                  const newButtons = selectedNodeInfo?.data?.buttons;
                  const storedValue = values.join("||");
                  newButtons[index][activeMappingOption.dataField] = storedValue;
                  updateNode(selectedNodeInfo.id, {
                    ...selectedNodeInfo?.data,
                    buttons: newButtons,
                  });
                  updateNode(button?.buttonNodeId, {
                    ...button,
                    [activeMappingOption.dataField]: storedValue,
                  });
                }}
                placeholder={activeMappingOption.placeholder}
                searchPlaceholder={activeMappingOption.searchPlaceholder}
                disabled={!isEditable}
              />
            );
          })()}
          <span
            style={{
              marginTop: "5px",
            }}
          >
            {button.buttonType === BUTTON_TYPE.BRANCH_BUTTON
              ? "Add new blocks from the port to configure it"
              : "Click on the URL icon to add the URL"}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          {isEditable && profileType === FLOW_TYPE_SCREENING && (
            <div className="icon-container" ref={ref}>
              <Select
                value={button?.assessmentValue || ""}
                onValueChange={(value) => {
                  setIsOpen(false);

                  const newButtons = selectedNodeInfo?.data?.buttons;
                  newButtons[index].assessmentValue = value;

                  updateNode(selectedNodeInfo.id, {
                    ...selectedNodeInfo?.data,
                    buttons: newButtons,
                  });
                  updateNode(button?.buttonNodeId, {
                    ...button,
                    assessmentValue: value,
                  });
                }}
                open={isOpen}
                onOpenChange={setIsOpen}
                disabled={!isEditable}
                key={selectedNodeInfo?.id}
              >
                <SelectTrigger className="h-auto w-auto premitive-remove border-0 border-remove bg-transparent p-0 shadow-none focus:ring-0">
                  <MoreVertical className="cursor-pointer " />
                </SelectTrigger>
                <SelectContent side="bottom" align="end" className="min-w-[120px]">
                  {buttonOptions.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          )}
          {selectedNodeInfo?.data?.buttons?.length > 1 && isEditable ? (
            <img
              src={DeleteIcon}
              alt="deleteIcon"
              onClick={async () => {
                const newButtons = selectedNodeInfo?.data?.buttons;
                newButtons.splice(index, 1);
                updateNode(selectedNodeInfo.id, {
                  ...selectedNodeInfo?.data,
                  buttons: newButtons,
                });
                await deleteNode(button?.buttonNodeId);
                saveData();
              }}
            />
          ) : null}
          {isEditable && atsPlatform && (profileType === FLOW_TYPE_SCREENING || profileType === FLOW_TYPE_RECONNECT) && mappingOptions.some((opt) => opt.platformType === atsPlatform) && (
            <div className="icon-container">
              <Popover open={isMappingOpen} onOpenChange={setIsMappingOpen}>
                <PopoverTrigger asChild>
                  <button type="button" className="border-0 bg-transparent mt-03 p-0 cursor-pointer">
                    <Tooltip title="Add mapping">
                                          <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#007372"><path d="M624-144v-108H444v-384H336v108H96v-288h240v108h288v-108h240v288H624v-108H516v312h108v-108h240v288H624ZM168-744v144-144Zm528 384v144-144Zm0-384v144-144Zm0 144h96v-144h-96v144Zm0 384h96v-144h-96v144ZM168-600h96v-144h-96v144Z" /></svg>
                    </Tooltip>
                  </button>
                </PopoverTrigger>
                <PopoverContent side="bottom" align="end" className="min-w-[180px] p-1">
                  {mappingOptions
                    .filter((option) => option.platformType === atsPlatform && (!option.screeningOnly || profileType === FLOW_TYPE_SCREENING))
                    .map((option) => {
                    const isSelected = button?.mappingType === option.value;
                    return (
                      <div
                        key={option.value}
                        role="option"
                        aria-selected={isSelected}
                        className="relative flex w-full cursor-pointer items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm hover:bg-accent hover:text-accent-foreground select-none"
                        onClick={() => {
                          setIsMappingOpen(false);
                          const newButtons = selectedNodeInfo?.data?.buttons;
                          if (isSelected) {
                            newButtons[index].mappingType = null;
                            mappingOptions.forEach((opt) => {
                              newButtons[index][opt.dataField] = "";
                            });
                          } else {
                            newButtons[index].mappingType = option.value;
                            newButtons[index].optionValue = "";
                            mappingOptions
                              .filter((opt) => opt.value !== option.value)
                              .forEach((opt) => {
                                newButtons[index][opt.dataField] = "";
                              });
                          }
                          const hasMappingAfterToggle = newButtons.some((btn) => btn.mappingType);
                          updateNode(selectedNodeInfo.id, {
                            ...selectedNodeInfo?.data,
                            buttons: newButtons,
                            ...(hasMappingAfterToggle ? { atsValue: "" } : {}),
                          });
                          updateNode(button?.buttonNodeId, {
                            ...button,
                            mappingType: isSelected ? null : option.value,
                          });
                        }}
                      >
                        {option.label}
                        {isSelected && (
                          <span className="absolute right-2 flex size-3.5 items-center justify-center">
                            <CheckIcon className="size-4" />
                          </span>
                        )}
                      </div>
                    );
                  })}
                </PopoverContent>
              </Popover>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function ButtonsNodeEditor() {
  const {
    selectedNodeInfo,
    updateNode,
    addButtonNode,
    variableList,
    atsData,
    isEditable,
    setNewAddedNode,
    saveData,
    profileType,
  } = useContext(NodeContext);
  const [displayError, setDisplayError] = useState(
    selectedNodeInfo.data.isVariableNameAlreadyUsed ?? false
  );

  // const [itemsArray, setItemsArray] = useState(
  //   selectedNodeInfo?.data?.buttons.map((item) => ({
  //     ...item,
  //     id: item?.id ?? uuidv4(),
  //   }))
  // );

  const handleAddButton = useCallback(
    (buttonType) => {
      const buttonNode = {
        type: NODE_TYPE.BUTTON_NODE,
        buttonType,
        titleText: `Choice ${selectedNodeInfo?.data?.buttons?.length + 1}`,
        buttonNodeId: uuidv4(),
        url: "",
        newTab: true,
        assessmentValue: "Shortlisted",
        id: uuidv4(),
      };

      addButtonNode(selectedNodeInfo, buttonNode);
      updateNode(selectedNodeInfo.id, {
        ...selectedNodeInfo?.data,
        buttons: [...selectedNodeInfo?.data?.buttons, buttonNode],
      });
    },
    [selectedNodeInfo, addButtonNode, updateNode]
  );

  // const itemRenderer = (button, index) => (
  //   <ButtonItem
  //     button={button}
  //     index={index}
  //     key={index}
  //     itemsArray={itemsArray}
  //     setItemsArray={setItemsArray}
  //   />
  // );

  // const reorder = (list, startIndex, endIndex) => {
  //   const result = Array.from(list);
  //   const [removed] = result.splice(startIndex, 1);
  //   result.splice(endIndex, 0, removed);

  //   return result;
  // };

  // const handleOnDragEnd = (result) => {
  //   if (!result.destination) return;
  //   const itemsCopy = reorder(
  //     itemsArray,
  //     result.source.index,
  //     result.destination.index
  //   );
  //   setItemsArray(itemsCopy);
  //   updateNode(selectedNodeInfo.id, {
  //     ...selectedNodeInfo?.data,
  //     buttons: itemsCopy,
  //   });
  // };

  // useEffect(() => {
  //   setItemsArray(
  //     selectedNodeInfo?.data?.buttons.map((item) => ({
  //       ...item,
  //       id: item?.id ?? uuidv4(),
  //     }))
  //   );
  // }, [selectedNodeInfo, nodes]);

  if (!selectedNodeInfo) {
    return null;
  }

  return (
    <>
      <TitleInputContainer>
        <FormLabelInput
          placeholder={ButtonNodeEditorConstants.TITLE_INPUT_PLACEHOLDER}
          value={selectedNodeInfo?.data?.titleText}
          onChange={(e) => {
            updateNode(selectedNodeInfo.id, {
              ...selectedNodeInfo?.data,
              titleText: e.target.value,
            });
          }}
          readOnly={!isEditable}
        />
        <TitleDescription>
          Buttons allow the conversation flow to be branched into various paths
          based on user input
        </TitleDescription>
      </TitleInputContainer>
      <MessageInputContainer>
        <FormLabel>{LABELS.SHOW_MESSAGE}</FormLabel>
        <Editor
          editorState={getHTMLToDraft(selectedNodeInfo?.data?.message)}
          onEditorStateChange={(data) => {
            const isMessageEmpty = data.getCurrentContent().hasText();
            updateNode(selectedNodeInfo.id, {
              ...selectedNodeInfo?.data,
              message: data,
              isMessageEmpty: !isMessageEmpty,
            });
          }}
          wrapperClassName="wrapper-class"
          editorClassName="editor-class"
          toolbarClassName="toolbar-class"
          toolbar={toolbar}
          mention={{
            separator: " ",
            trigger: "{",
            suggestions: variableList,
          }}
          onBlur={() => {
            setNewAddedNode(true);
          }}
          placeholder="What is your..."
          readOnly={!isEditable}
          stripPastedStyles={true}
        />
      </MessageInputContainer>
      {/* <div> */}
      <ButtonsListContainer>
        {selectedNodeInfo?.data?.buttons?.map((button, index) => {
          return (
            <ButtonItem
              button={button}
              index={index}
              key={button?.buttonNodeId}
            />
          );
        })}
        {/* <DraggableList
            itemsArray={itemsArray}
            setItemsArray={setItemsArray}
            handleOnDragEnd={handleOnDragEnd}
            itemRenderer={itemRenderer}
            isEditable={isEditable}
            key={`${selectedNodeInfo.id}-draggableList`}
          /> */}
      </ButtonsListContainer>
      {/* </div> */}

      {selectedNodeInfo?.data?.buttons?.length < 20 && isEditable ? (
        <ActionButtonContainer>
          <Button
            variant="outline"
            onClick={async () => {
              await handleAddButton(BUTTON_TYPE.BRANCH_BUTTON);
              saveData();
            }}
          >
            <img src={AddIcon} alt="addIcon" />
            Choice
          </Button>
        </ActionButtonContainer>
      ) : null}
      <div className="response-container text-base font-normal">
        <FormLabel>Enable multiselect option</FormLabel>
        <Tooltip title="Enable multiselect options">
          <span>
            <Switch
              checked={
                selectedNodeInfo?.data.isMultiSelect
                  ? selectedNodeInfo?.data.isMultiSelect
                  : false
              }
              onCheckedChange={(checked) => {
                updateNode(selectedNodeInfo.id, {
                  ...selectedNodeInfo?.data,
                  isMultiSelect: checked,
                });
              }}
              disabled={!isEditable}
            />
          </span>
        </Tooltip>
      </div>
      <InputContainer>
        {atsData && (
          <>
            <FormLabel>{LABELS.ATS_FIELD}</FormLabel>
            <EdsSearchableSelect
              options={atsData}
              value={selectedNodeInfo?.data?.atsValue || ""}
              onChange={(value) => {
                updateNode(selectedNodeInfo.id, {
                  ...selectedNodeInfo?.data,
                  atsValue: value || "",
                });
                setTimeout(() => {
                  saveData();
                }, 10);
              }}
              isDisabled={!isEditable || selectedNodeInfo?.data?.buttons?.some((btn) => btn.mappingType)}
              placeholder="Select ATS Field"
              key={selectedNodeInfo?.id}
            />
          </>
        )}
        <ResponseVariable
          updateNodeFun={updateNode}
          selectedNodeInfo={selectedNodeInfo}
          iseditable={isEditable ? "true" : undefined}
        />
        <div className="relative flex w-full items-center justify-between gap-0.5">
          <FormInput
            placeholder="Enter Variable Name"
            value={selectedNodeInfo?.data?.variableName}
            onBlur={(e) => {
              setNewAddedNode(true);
            }}
            onChange={(e) => {
              if (e.target.value.length > 60) {
                return;
              }
              const isVariableNameAlreadyUsed = variableList.find(
                (item) => item.value === `{${e.target.value.trim()}}}`
              );
              if (isVariableNameAlreadyUsed) {
                setDisplayError(true);
              } else {
                setDisplayError(false);
              }

              updateNode(selectedNodeInfo.id, {
                ...selectedNodeInfo?.data,
                variableName: e.target.value,
                isVariableNameAlreadyUsed: isVariableNameAlreadyUsed
                  ? true
                  : false,
              });
            }}
            readOnly={!isEditable}
          />
          {displayError && (
            <Tooltip title="This variable has already been used.">
              <AlertTriangle
                className="absolute right-10 text-[#ffcc00]"
                size={18}
              />
            </Tooltip>
          )}
        </div>
        <FormNote className="mb-0">
          You can add a variable that can be referenced later in the
          conversation.
        </FormNote>
      </InputContainer>
      {[FLOW_TYPE_SCREENING, FLOW_TYPE_RECONNECT, FLOW_TYPE_FAQ].includes(profileType) && (
        <InputContainer className="mt-0 mb-0">
          <div className="flex items-center justify-between">
            <FormLabel className="mb-0">{LABELS.SKIPPABLE}</FormLabel>
            <Tooltip title="When enabled, the candidate can skip this question without providing an answer">
              <span>
                <Switch
                  checked={selectedNodeInfo?.data?.isSkippable ?? false}
                  onCheckedChange={(checked) => {
                    updateNode(selectedNodeInfo.id, {
                      ...selectedNodeInfo?.data,
                      isSkippable: checked,
                      ...(!checked && { skipToNodeId: "" }),
                    });
                  }}
                  disabled={!isEditable}
                />
              </span>
            </Tooltip>
          </div>
          <SkipToQuestionDropdown />
        </InputContainer>
      )}
    </>
  );
}

export default ButtonsNodeEditor;
